import { ReactElement } from "react";
import { isTMessage, TMessage } from "@/i18n/tt";
import { useTranslation } from "@/stores/RootStoreContext";
import { Markdown } from "@/text/Markdown";
import { Popover } from "./Popover";
import { Icon, IconColor } from "./Icon";
import { VBox } from "./Box";
import { IconName } from "./iconMapping";

export type InfoButtonProps = {
  infoText?: ReactElement | TMessage | string | number;
  color?: IconColor;
  icon?: IconName;
  disableMaxWidth?: boolean;
};

export function InfoButton({ infoText, icon, color, disableMaxWidth }: InfoButtonProps) {
  const { tf } = useTranslation();

  const renderInfoText = () => {
    if (typeof infoText === "string" || isTMessage(infoText)) {
      return <Markdown value={tf(infoText)} disableLastMargin enableLinks />;
    }
    return infoText;
  };

  return infoText ? (
    <Popover
      button={
        <button
          className={"inline-flex align-text-bottom"}
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
        >
          <Icon name={icon ?? "info"} color={color ?? "info"} />
        </button>
      }
      content={<VBox maxWidth={disableMaxWidth ? undefined : "prose"}>{renderInfoText()}</VBox>}
    />
  ) : null;
}
